import {
  GetTelemetryHistoryResponse,
  getTelemetryHistoryIntervals,
  TelemetryHistoryPeriod,
} from '@eppendorf/vnls-device-service-utils';

export function toStabilityReportChartData(
  data: GetTelemetryHistoryResponse,
  period: TelemetryHistoryPeriod,
): GetTelemetryHistoryResponse {
  return {
    ...data,
    historyData: getTelemetryHistoryIntervals(data, period).flatMap(({ point, end }) => [
      point,
      { ...point, timestamp: end, date: new Date(end).toISOString() },
    ]),
  };
}
